export default __webpack_public_path__ + "static/media/room-10.681615dc.jpg";